import i18next from "i18next"
import HLocalStorage from "./localStorage"
import { HCF } from "@macashipo/mlib"
import { HApi } from "."
import { appLangBundles } from "src/modules/app_dnt/lang/i18n"

const KLanguage = "lang"
const KDefaultLang = "defaultLang"
const KVersionLang = "currentVersionLang"
const KDefaultLangBundles = "defaultLangBundles"
const KLocalLangBundles = "langBundles"

interface LangConfig {
  ver: string
  data: any
  lang: string
}
export const initI18n = (config?: any) => {
  const lang = HLocalStorage.getString(KLanguage, "")
  const localLangBundles = HLocalStorage.getObj(KLocalLangBundles, null as any)
  if (lang) {
    config.lng = lang
  } else {
    config.lng = HCF.getCF(KDefaultLang)
    HLocalStorage.saveString(KLanguage, config.lng)
  }
  if (localLangBundles) {
    config.resources[lang] = localLangBundles
  }
  i18next.init(config)
}
export const getCurrentLang = () => {
  return HLocalStorage.getString(KLanguage, "")
}
export const getPlaceholderText = (type, textSuffix) => {
  const rg =
    /<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i
  let text = textSuffix
  if (rg.test(text)) {
    let span = document.createElement("span")
    span.innerHTML = text
    text = span.textContent || span.innerText
  }
  switch (type) {
    case "enter":
      return `${i18next.t("placeholder prefix.Enter")} ${text}`
    case "select":
      return `${i18next.t("placeholder prefix.Select")} ${text}`
    default:
      return textSuffix
  }
}
export const parseLangConfig = (
  langConfig: LangConfig,
  keyLangBundles: any = null
) => {
  if (langConfig) {
    const currentVersionLang = HCF.getCF(KVersionLang)
    const sLang = langConfig?.lang
    const sVersionLang = langConfig?.ver
    const sLangBundles = langConfig?.data
    if (sVersionLang !== currentVersionLang) {
      updateLanguage()
    } else {
      const defaultLangBundles =
        keyLangBundles || HCF.getCF(KDefaultLangBundles)
      if (defaultLangBundles && Array.isArray(defaultLangBundles)) {
        if (Object.keys(sLangBundles).length > 0 && sLang) {
          HLocalStorage.saveString(KLanguage, sLang)
          defaultLangBundles.forEach(v => {
            i18next.addResourceBundle(sLang, v, sLangBundles[v])
          })
          HLocalStorage.saveObj(
            KLocalLangBundles,
            i18next.getDataByLanguage(sLang) || {}
          )
          i18next.changeLanguage(sLang)
        }
      }
    }
  }
}
export const updateLanguage = () => {
  // Init bo text chung o client de cap nhat dung
  if (appLangBundles) {
    Object.keys(appLangBundles).forEach(v => {
      i18next.addResourceBundle("ui", v, appLangBundles[v])
    })
  }
  const languageBundles = i18next.getDataByLanguage("ui")
  if (languageBundles) {
    HApi.apiPost({
      path: "SystemLanguageData",
      name: "UpdateLanguage",
      data: {
        LangData: {
          Version: HCF.getCF(KVersionLang),
          Data: languageBundles,
          Lang: HCF.getCF(KDefaultLang),
        },
      },
    })
      .then(response => {
        if (response?.Data?.NeedReloadPage) {
          window.location.reload()
        }
      })
      .catch(error => {})
  }
}
